import { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/ui/Layout'
import HomePage from './pages/HomePage'
import DecksPage from './pages/DecksPage'
import DeckDetailPage from './pages/DeckDetailPage'
import DeckBuilderPage from './pages/DeckBuilderPage'
import BattleArenaPage from './pages/BattleArenaPage'
import EvolutionLabPage from './pages/EvolutionLabPage'
import SpacesPage from './pages/SpacesPage'
import CardBrowserPage from './pages/CardBrowserPage'
import PackPage from './pages/PackPage'
import { useAppStore } from './store'
import { api } from './services/api'

function App() {
  const { actions } = useAppStore()
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    api.getCards({ limit: 20 })
      .then((result) => {
        console.log(`Loaded ${result.data?.length || 0} cards`)
        if (result.data) {
          actions.setCards(result.data)
        }
        setLoaded(true)
      })
      .catch((err) => {
        console.error('Failed to load cards:', err)
        setLoaded(true)
      })
  }, [actions])

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cards" element={<CardBrowserPage />} />
        <Route path="/decks" element={<DecksPage />} />
        <Route path="/deck/new" element={<DeckBuilderPage />} />
        <Route path="/deck/:id" element={<DeckDetailPage />} />
        <Route path="/deck/:id/edit" element={<DeckBuilderPage />} />
        <Route path="/packs" element={<PackPage />} />
        <Route path="/battle" element={<BattleArenaPage />} />
        <Route path="/evolution" element={<EvolutionLabPage />} />
        <Route path="/spaces" element={<SpacesPage />} />
        <Route path="/spaces/:slug" element={<SpacesPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
